import {createRouter, createWebHistory} from 'vue-router';
import {Routes} from '@/constants/family-details.js';
import store from '@/store';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:countryCode/:locale/:breadcrumbs*/f/:familyId/:modelName?/:modelCode?/:sku?',
      name: Routes.FAMILY_DETAILS_PAGE,
      component: () => import('@/familyDetailsPage/views/FamilyDetailsPageView.vue'),
      beforeEnter(to, from) {
        if (to.name !== from.name) {
          store?.commit('productDetails/setIsCustomizationMode', false, {root: true});
        }
      },
    },
    {
      path: '/:countryCode/:locale/:breadcrumbs*/f/:familyId/:modelName?/:modelCode?/custom/:buildId?',
      name: Routes.FDP_CUSTOMIZED_BUILD,
      component: () => import('@/familyDetailsPage/views/FamilyDetailsPageView.vue'),
      beforeEnter(to, from) {
        if (to.name !== from.name) {
          store?.commit('productDetails/setIsCustomizationMode', true, {root: true});
        }
      },
    },
  ],
});

export default router;
